<template>
  <div>
    <el-popover v-model="visible" placement="top" width="300" title="輸出目前條件資料到EXCEL" @show="exportExcel" @hide="clearData">
      <el-input v-model="customFileName" :placeholder="placeholder" prefix-icon="el-icon-document" class="mb-2" />
      <div style="text-align: right; margin: 0" v-loading="is_loading">
        <el-button size="medium" type="text" @click="visible = false">取消</el-button>
        <vue-excel-xlsx :data="exportData" :columns="columns" :file-name="customFileName ? customFileName : filename" :sheet-name="'工作表1'">
          <el-button type="success" size="medium" @click="exportExcel"> 儲存EXCEL </el-button>
        </vue-excel-xlsx>
      </div>
      <el-button slot="reference" type="primary">輸出EXCEL</el-button>
    </el-popover>
  </div>
</template>
<script>
const methods = {
  exportExcel() {
    this.$emit('onExportClick');
  },
  clearData() {
    this.$emit('clearData');
    this.is_loading = true;
  },
};
export default {
  watch: {
    exportData: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.is_loading = false;
        }
      },
    },
  },
  created() {},
  props: ['exportData', 'columns', 'filename'],
  data() {
    return {
      customFileName: '',
      visible: false,
      is_loading: true,
    };
  },
  computed: {
    placeholder() {
      return `請輸入檔案名稱 (預設檔名為現在時間)`;
    },
  },
  methods,
};
</script>
<style>
button {
  background: rgba(255, 255, 255, 0);
  border: 0;
}
</style>
